import React from 'react'
import classNames from 'classnames/bind'
import { Container } from 'modules/marketplace/layout/components/ResponsiveContainers'

import 'swiper/css'
import 'swiper/css/free-mode'
import styles from './RelatedContentSection.module.css'
const cx = classNames.bind(styles)

type ProductListProps = {
  title?: string
  classname?: string
  children: React.ReactNode
  isTinted?: boolean
}

const RelatedContentSection = ({ title, classname, children, isTinted = false }: ProductListProps) => (
  <section className={cx(styles.relatedContent, classname, { isTinted })}>
    {title && (
      <Container>
        <h3 className={styles.title}>{title}</h3>
      </Container>
    )}
    {children}
  </section>
)

export default RelatedContentSection
